import { AddOrEditIntegrationDrawerFooter } from '@modules/integrationsV2/components/AddOrEditIntegrationDrawerFooter';
import { AddOrEditIntegrationDrawerHeader } from '@modules/integrationsV2/components/AddOrEditIntegrationDrawerHeader';
import { useUpdateIntegration } from '@modules/integrationsV2/hooks';
import {
  getAddIntegrationDrawerHeaderTitle,
  trackIntegrationEvent,
} from '@modules/integrationsV2/utils';
import { GetAddIntegrationFormDrawerContentProps } from '@modules/integrationsV2/utils/getAddIntegrationFormDrawerContent';
import { Box, Stack, TextField } from '@mui/material';
import {
  IntegrationChannelType,
  IntegrationDirection,
} from 'generated/graphql';
import { useState } from 'react';
import useCreateIntegrationEdgeServer from 'v2/core/repository/edge-server/integrations';
import { IsLoading } from 'v2/core/repository/edge-server/types';
import { useGetUser } from 'v2/core/services/user';

export const SprigFormDrawerContent = ({
  integrationType,
  integrationChannel,
  onDrawerClose,
  integrationID,
}: GetAddIntegrationFormDrawerContentProps) => {
  const {
    id: userID,
    tenant: { id: tenantID },
  } = useGetUser();

  const [apiKey, setApiKey] = useState('');

  const { status: createIntegrationStatus, createIntegration } =
    useCreateIntegrationEdgeServer({
      tenantID,
      direction: IntegrationDirection.Inbound,
      channel: IntegrationChannelType.Sprig,
      integrationType,
      createdByUser: userID,
      inputData: {
        sprig: {
          apiKey,
        },
      },
      onCompleted: () => {
        onDrawerClose();
        trackIntegrationEvent({
          eventName: 'Integration Added',
          integrationChannelType: IntegrationChannelType.Sprig,
        });
      },
    });

  const [updateIntegration, { status: updateIntegrationStatus }] =
    useUpdateIntegration({
      action: 'reauth',
      channelType: integrationChannel.type,
      integrationType,
      onCompleted: () => {
        onDrawerClose();
      },
    });

  const isReauthorizeForm = !!integrationID;

  const onSubmit = () => {
    if (isReauthorizeForm) {
      updateIntegration({
        integrationID,
        isActive: true,
        updateAuthData: {
          sprig: {
            apiKey,
          },
        },
      });
    } else {
      createIntegration();
    }
  };

  const isDisabled = !apiKey.trim();

  const isLoading =
    IsLoading(createIntegrationStatus) || IsLoading(updateIntegrationStatus);

  return (
    <Stack height="100%" justifyContent="space-between">
      <Box>
        <AddOrEditIntegrationDrawerHeader
          integrationChannel={integrationChannel}
          integrationType={integrationType}
          title={getAddIntegrationDrawerHeaderTitle(
            integrationChannel,
            integrationType,
          )}
          isReauthorizeForm={isReauthorizeForm}
        />
        <Stack p={3} spacing={4}>
          <TextField
            required
            fullWidth
            label="API Key"
            placeholder="Enter API Key"
            variant="outlined"
            onChange={(e) => setApiKey(e.target.value)}
            disabled={isLoading}
          />
        </Stack>
      </Box>
      <AddOrEditIntegrationDrawerFooter
        onCancel={onDrawerClose}
        onSubmit={onSubmit}
        buttonText={isReauthorizeForm ? 'Reauthorize' : 'Integrate'}
        isDisabled={isDisabled}
        isLoading={isLoading}
      />
    </Stack>
  );
};
